export default "__VITE_ASSET__0880f250__"